/**
 * Max guests from searchSlots payload (slot or theatre level).
 */
export function resolveMaxGuests(slot, theater) {
  const raw =
    slot?.maxGuests ??
    slot?.MaxGuests ??
    theater?.maxGuests ??
    theater?.MaxGuests;
  const n = Number(raw);
  if (Number.isFinite(n) && n >= 1) return Math.floor(n);
  return 30;
}

/**
 * Guest count bounds from theatre meta only (searchSlots theatre row): {@code minGuests} … {@code maxGuests}.
 */
export function resolveTheatreGuestBounds(theatre) {
  const minRaw = Number(theatre?.minGuests ?? theatre?.MinGuests ?? 1);
  const maxRaw = Number(theatre?.maxGuests ?? theatre?.MaxGuests ?? 30);
  let minG = Number.isFinite(minRaw) && minRaw >= 1 ? Math.floor(minRaw) : 1;
  let maxG = Number.isFinite(maxRaw) && maxRaw >= 1 ? Math.floor(maxRaw) : 30;
  if (maxG < minG) {
    maxG = minG;
  }
  return { minGuests: minG, maxGuests: maxG };
}

/** Merge theatre-level MaxGuests onto slot for booking steps. */
export function enrichSlotFromTheatre(slot, theater) {
  if (!slot || typeof slot !== "object") return slot;
  return { ...slot, maxGuests: resolveMaxGuests(slot, theater) };
}
